App.controller('renameCtrl', ($scope) => {
  $scope.orig = $scope.ngDialogData.name
  $scope.vm = {
    name: $scope.ngDialogData.name
  }

  $scope.title = $scope.ngDialogData.title
  $scope.custom_confirm = $scope.ngDialogData.custom_confirm
  $scope.custom_cancel = $scope.ngDialogData.custom_cancel

  $scope.save = () => {
    $scope.closeThisDialog({newName: $scope.vm.name})
  }

  $scope.cancel = () => {
    $scope.closeThisDialog(false)
  }
})
